import React from 'react'
import './card.css'

function Shimmer() {
  return (
    <div className="shimmer-wrapper">
      <div className="shimmer"></div>
    </div>
  )
}

export default Shimmer